const PERMISSION_KEY= "crm:config_system";
const PAGE_URL = {
    CONFIG_SYSTEM_PAGE: "/admin/crm/config-system"
}

export {PERMISSION_KEY, PAGE_URL}

